import { Loader2 } from "lucide-react";

export const PageLoader = () => (
  <div data-testid="page-loader" className="flex items-center justify-center min-h-[40vh] text-slate-400">
    <Loader2 className="w-6 h-6 animate-spin" />
  </div>
);
